import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../contexts/AuthContext';

const RoleDashboardRedirect: React.FC = () => {
  const user = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on user role
  switch (user.role) {
    case 'researcher':
      return <Navigate to="/researcher/dashboard" replace />;
    case 'evaluator':
      return <Navigate to="/evaluator/dashboard" replace />;
    case 'admin':
      return <Navigate to="/admin/dashboard" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default RoleDashboardRedirect;